import { path } from 'ramda';

export const popularCompanyAverageSalaryBoxSelector = path([
  'popularCompanyAverageSalary',
]);
